import  i18n, { selectedLocale }  from '@/services/i18n'

export default ({
    state: {
        userSelectedLocale: selectedLocale,
    },
    mutations: {
        UPDATE_SELECTED_LOCALE(state, newLocale) {
            let userSelectedLocale = sessionStorage.getItem("userSelectedLocale")
            if((newLocale === undefined || newLocale === null) && userSelectedLocale !== undefined){
                state.userSelectedLocale = userSelectedLocale
            }else {
                sessionStorage.setItem("userSelectedLocale", newLocale)
                state.userSelectedLocale = newLocale
            }
        }
    },
    actions: {
        changeLocale({ commit }, newLocale) {
            i18n.locale = newLocale // set the locale directly!
            commit('UPDATE_SELECTED_LOCALE', newLocale)
        }
    },
    getters: {
        getUserSelectedLocale(state){
            return state.userSelectedLocale;},
    }
})